import Action from "../classes/Action";
import Engine from "../classes/Engine";
import {GroupsManager} from '../classes/GroupsManager';
import { CustomEventTypes } from "../globals";
import { IObjectSelection } from '../interfaces/Misc';

export default class SelectGroupAction extends Action
{
	constructor(groupGuid: string | null)
	{
		let actionName;
		if (groupGuid)
		{
			const groupName = GroupsManager.getGroupByGuid(groupGuid)?.name;
			actionName = "Selected Group " + groupName;
		}
		else
		{
			actionName = "Cleared Group Selection";
		}

		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();
		super([groupGuid], [previousSelection], actionName, [groupGuid]);
	}

	do(groupGuid: string | null) : void
	{	
		Engine.getInstance().getPickingManager().clearSelection(false);
		if (groupGuid) Engine.getInstance().getPickingManager().selectGroup(groupGuid);
		Engine.getInstance().getPickingManager().storeSelection();

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	undo(previousSelection: IObjectSelection) : void
	{
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);
	}

	verify(groupGuid: string) : boolean
	{
		if (groupGuid)
		{
			return GroupsManager.getGroupByGuid(groupGuid) !== undefined && groupGuid !== Engine.getInstance().getPickingManager().getCurrentSelection().groupGuid;
		}
		else
		{
			return (Engine.getInstance().getPickingManager().getCurrentSelection().groupGuid !== undefined);
		}
	}
}
